import { render, staticRenderFns } from "./email-to-friend.vue?vue&type=template&id=f5154062&lang=html"
import script from "./email-to-friend.vue?vue&type=script&lang=js"
export * from "./email-to-friend.vue?vue&type=script&lang=js"
import style0 from "./email-to-friend.vue?vue&type=style&index=0&id=f5154062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports